import React, {useEffect} from "react"
import {Field, Formik} from "formik"
import {Form, message} from "antd"
import useTranslation from 'next-translate/useTranslation'

// Components
import UnauthorizedPage from "../../../../components/UnauthorizedPage"
import {Input} from "../../../../components/createFormItem"
import AuthFormPlate from "../../components/AuthFormPlate"
import Button from "../../../../components/Button"

// Models
import {ChangePasswordPageProps} from "../../../../../pages/reset-password"

// Constants
import {Routes} from "../../../../constants"

// Hooks
import usePrevious from "../../../../hooks/usePrevious"

const ResetPasswordPage = (props: ChangePasswordPageProps): JSX.Element => {
    const {
        className,
        router,
        resetPassword,
        passwordResetSending,
        passwordResetSent,
        utils: {
            validateEmail,
        },
    } = props;
    const previousPasswordResetSending = usePrevious(passwordResetSending)
    const { t } = useTranslation();

    useEffect(() => {
        if (typeof previousPasswordResetSending !== "undefined" && previousPasswordResetSending !== passwordResetSending && passwordResetSent) {
            message.success(t('common:auth.please_check_your_email_text'))
            void router.push(Routes.SIGN_IN)
        }
    }, [passwordResetSending, passwordResetSent])

    const handleBack = () => {
        void router.push(Routes.SIGN_IN)
    }

    const handleSubmit = values => {
        resetPassword(values.email)
    }

    return (
        <UnauthorizedPage title={t('common:auth.forgot_password')} className={className}>
            <AuthFormPlate
                handleBack={handleBack}
                title={t('common:auth.reset_password')}
                description={t('common:auth.enter_your_email_below')}
            >
                <Formik
                    onSubmit={handleSubmit}
                    initialValues={{email: ""}}
                >
                    {({handleSubmit, isValid}) => (
                        <Form onFinish={handleSubmit}>
                            <Field
                                name="email"
                                type="email"
                                placeholder={t('common:email')}
                                validate={validateEmail}
                                component={Input}
                            />
                            <Button
                                block
                                type="primary"
                                htmlType="submit"
                                loading={isValid && passwordResetSending}
                                disabled={isValid === false}
                            >
                                {t('common:reset')}
                            </Button>
                        </Form>
                    )}
                </Formik>
            </AuthFormPlate>
        </UnauthorizedPage>
    )
}

export default ResetPasswordPage